import { createContext } from "react";

const reservasContext = createContext();

export default reservasContext;
